// extracted by mini-css-extract-plugin
export default {"searchInputGroup":"filters_searchInputGroup__CHclc"};